import { HashMap } from '@ngneat/transloco';
import { TranslationId } from '@platform-frontend/util';
import { TRANSLOCO_TRANSLOCO_SCOPE } from './transloco-transloco-scope';

export const buildNotificationTranslationId: (key: string, params?: HashMap, scope?: string) => TranslationId = (
  key: string,
  params: HashMap = {},
  scope?: string
) => ({
  key: (scope ? scope + '.' : '') + 'notification.' + key,
  params,
  scope
});

const buildTranslationId: (key: string, params?: HashMap) => TranslationId = (key: string, params: HashMap = {}) =>
  buildNotificationTranslationId(key, params, TRANSLOCO_TRANSLOCO_SCOPE);

// Language related errors
export const MSG_LANGUAGE_NOT_AVAILABLE_GERMAN = buildTranslationId('languageNotAvailable.german');
